import { graphql } from "api/cms-website/generated";

import { IconFragment } from "./icon";

export const ButtonFragment = graphql(/* GraphQL */ `
    fragment ButtonFragment on ComponentElementsButton {
        text
        variant
        link {
            ...LinkFragment
        }
        iconRight {
            ...IconFragment
        }
    }
    ${IconFragment}
`);
